import { render, staticRenderFns } from "./IslandPreview.vue?vue&type=template&id=bc4f41fc&scoped=true&"
import script from "./IslandPreview.vue?vue&type=script&lang=js&"
export * from "./IslandPreview.vue?vue&type=script&lang=js&"
import style0 from "./IslandPreview.vue?vue&type=style&index=0&id=bc4f41fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4f41fc",
  null
  
)

export default component.exports